import axios from '@axios';

const base = '/api/v1/contacts/';

export default {
  getContacts() {
    return axios.get(`${base}mdm-user`)
  },
};
